import { MOCK_API } from "src/config/env";
import config from "./config.json";
import analyticConfig from "./analytics.json";
import myCustomerReportsConfig from "./myCustomerReports.json";
import menuConfig from "./menu.config.json";
import whatsNewsConfig from "./whatsNews.config.json";
import { AnalyticEventName, MenuConfig, MyCustomerReportConfig, WhatsNewsConfig } from "./types";

if (MOCK_API) {
    config.enableLoginPage = true;
    config.enableBlocking = true;
}

export default Object.assign(config, {
    menuConfig: menuConfig as Zeta.Dictionary<MenuConfig>,
    whatsNewsConfig: whatsNewsConfig as Zeta.Dictionary<WhatsNewsConfig>,
    myCustomerReportsConfig: myCustomerReportsConfig as Zeta.Dictionary<MyCustomerReportConfig>,
    analyticConfig: analyticConfig as Record<AnalyticEventName, object[]>,
});
